/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CustomerTitleDto } from '../models/PagedResultDto_CustomerTitleDto';
import type { Wealthlane_CustomerService_Dtos_CustomerTitle_CreateCustomerTitleDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerTitle_CreateCustomerTitleDto';
import type { Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto';
import type { Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerTitleService {

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerTitleCustomerTitle(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerTitle_CreateCustomerTitleDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-title/customer-title',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppCustomerTitleCustomerTitle(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerTitle_UpdateCustomerTitleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/customer-title/customer-title',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerTitleByCompanyId(
id: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-title/{id}/by-company-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerTitleId 
     * @returns Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerTitleCustomerTitle(
customerTitleId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-title/customer-title/{customerTitleId}',
            path: {
                'customerTitleId': customerTitleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerTitleId 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppCustomerTitleCustomerTitle(
customerTitleId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/customer-title/customer-title/{customerTitleId}',
            path: {
                'customerTitleId': customerTitleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CustomerTitleDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerTitleCustomerTitleList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CustomerTitleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-title/customer-title-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerTitleCustomerTitles(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerTitle_CustomerTitleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-title/customer-titles',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
